import { styled } from "@mui/material/styles";
import UploadIcon from "designSystem/components/icon/UploadIcon";
import Button from "designSystem/components/button/Button";
import FlexRowCenter from "designSystem/components/flex/FlexRowCenter";
import html from "csi/html";
import React, { FunctionComponent, useState } from "react";
import TextField, { TextFieldProps } from "../textfield/TextField";

const PREFIX = "FileSelect";

const classes = {
	buttonBorder: `${PREFIX}buttonBorder`,
	fileInputBorder: `${PREFIX}fileInputBorder`,
};

const StyledFlexRowCenter = styled(FlexRowCenter)(({
	theme,
}) => ({
	[`& .${classes.buttonBorder}`]: {
		borderBottomLeftRadius: 0,
		borderTopLeftRadius: 0,
	},

	[`& .${classes.fileInputBorder}`]: {
		borderTopRightRadius: 0,
		borderBottomRightRadius: 0,
	},
}));

interface FileSelectProps extends TextFieldProps {
	onFileSelect: (file: File) => void;
}

const FileSelect: FunctionComponent<FileSelectProps> = (props) => {
	const { onFileSelect, ...otherProps } = props;
	const [selectedFile, setSelectedFile] = useState<File>(null);

	const attachFiles = async () => {
		const files = await html.selectFile();
		setSelectedFile(files[0]);
		onFileSelect(files[0]);
	};

	return (
		<StyledFlexRowCenter>
			<TextField
				{...otherProps}
				InputProps={{ className: classes.fileInputBorder }}
				autoFocus
				name="file"
				value={selectedFile?.name ?? ""}
			/>
			<Button
				className={classes.buttonBorder}
				design="secondary"
				onClick={attachFiles}
				startIcon={<UploadIcon />}
			/>
		</StyledFlexRowCenter>
	);
};

export default FileSelect;